// extracted by mini-css-extract-plugin
module.exports = {"factoids-container":"dece2e673c--factoids-container--oRuIi","factoid":"dece2e673c--factoid--IXK0u"};